import React, { ReactNode } from 'react';

import { Box, createStyles } from '@mantine/core';
import { ContentSection } from 'components/ExtractedContent/ExtractedContentPreview/ContentSection';
import { Header } from 'components/ExtractedContent/ExtractedContentPreview/Header';

interface ExtractedContentPreviewProps {
  title: string;
  subtitleComponent?: ReactNode;
  content: string;
  contentKey: string;
}

const useStyles = createStyles(() => ({
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  }
}));

export function ExtractedContentPreview({ title, subtitleComponent, content }: ExtractedContentPreviewProps) {
  const { classes } = useStyles();

  return (
    <Box className={classes.container}>
      <Header title={title} subtitleComponent={subtitleComponent} />
      <ContentSection content={content} />
    </Box>
  );
}
